import type { TableColumnKey } from "store/types";

export interface ColumnDef {
  key: TableColumnKey;
  label: string;
  minWidth: number;
}

export const ALL_COLUMNS: ColumnDef[] = [
  { key: "name", label: "Fund Name", minWidth: 75 },
  { key: "assetClass", label: "Asset Class", minWidth: 62 },
  { key: "strategy", label: "Strategy", minWidth: 58 },
  { key: "vintage", label: "Vintage", minWidth: 42 },
  { key: "geography", label: "Geography", minWidth: 52 },
  { key: "nav", label: "NAV", minWidth: 48 },
  { key: "committed", label: "Committed", minWidth: 55 },
  { key: "called", label: "Called", minWidth: 42 },
  { key: "distributed", label: "Distributed", minWidth: 55 },
  { key: "irr", label: "IRR", minWidth: 50 },
  { key: "moic", label: "MOIC", minWidth: 50 },
  { key: "dpi", label: "DPI", minWidth: 45 },
  { key: "rvpi", label: "RVPI", minWidth: 50 }
];

export function getMinWidths(keys: TableColumnKey[]): number[] {
  return keys.map((k) => ALL_COLUMNS.find((c) => c.key === k)?.minWidth ?? 65);
}
